<template>
  <Modal name="gong-animation-modal" class="gong-animation-modal" custom>
    <GongAnimation />
  </Modal>
</template>

<script lang="ts">
import Vue from 'vue';
import GongAnimation from './GongAnimation.vue';
import Modal from '~/components/common/Modal/Modal.vue';

export default Vue.extend({
  name: 'GongAnimationModal',
  components: { GongAnimation, Modal },
});
</script>

<style lang="scss" scoped>
.gong-animation-modal {
  background: black;
}
</style>
